import Active from '@/pages/Integrations/icons/Active';
import AppSell from '@/pages/Integrations/icons/AppSell';
import Astron from '@/pages/Integrations/icons/Astron';
import Bot from '@/pages/Integrations/icons/Bot';
import Cademi from '@/pages/Integrations/icons/Cademi';
import Eagle from '@/pages/Integrations/icons/EagleLabs';
import JetpackIcon from '@/pages/Integrations/icons/Jetpack';
import Enotas from '@/pages/Integrations/icons/Enotas';
import Hotzap from '@/pages/Integrations/icons/Hotzap';
import Memberkit from '@/pages/Integrations/icons/Memberkit';
import Mex from '@/pages/Integrations/icons/Mex';
import Nemu from '@/pages/Integrations/icons/Nemu';
import Notaz from '@/pages/Integrations/icons/Notaz';
import RedTracky from '@/pages/Integrations/icons/RedTracky';
import RedRock from '@/pages/Integrations/icons/RedRock';
import ShipOffers from '@/pages/Integrations/icons/ShipOffers';
import Sms from '@/pages/Integrations/icons/Sms';
import Tb3 from '@/pages/Integrations/icons/Tb3';
import UtmKit from '@/pages/Integrations/icons/UtmKit';
import Voxuy from '@/pages/Integrations/icons/Voxuy';
import Vturb from '@/pages/Integrations/icons/Vturb';
import Webhook from '@/pages/Integrations/icons/Webhook';
import Xtracky from '@/pages/Integrations/icons/Xtracky';
import TaukIcon from '@/pages/Integrations/icons/Tauk';
import HelpGridIcon from '@/pages/Integrations/icons/HelpGrid';
import { useTranslation } from 'react-i18next';

export const IntegrationsList = (isStaging: boolean) => {
  const { t } = useTranslation('integration');

  const allIntegrations = [
    {
      id: 10,
      name: 'Memberkit',
      icon: <Memberkit />,
      description: t('integration:memberkitDescription'),
      disabled: false,
      route: '/memberkit',
      category: 'memberArea',
    },
    {
      id: 11,
      name: 'Cademi',
      icon: <Cademi />,
      description: t('integration:cademiDescription'),
      disabled: false,
      route: '/cademi',
      category: 'memberArea',
    },
    {
      id: 12,
      name: 'Astron Members',
      icon: <Astron />,
      description: t('integration:astronDescription'),
      disabled: false,
      route: '/astron_members',
      category: 'memberArea',
    },
    {
      id: 13,
      name: 'App Sell',
      icon: <AppSell />,
      description: t('integration:appSellDescription'),
      disabled: false,
      route: '/app_sell',
      category: 'memberArea',
    },
    // Tracking
    {
      id: 14,
      name: 'UTMify',
      icon: <UtmKit />,
      description: t('integration:utmifyDescription'),
      disabled: false,
      route: '/utmify',
      category: 'tracking',
    },
    {
      id: 15,
      name: 'Nemu',
      icon: <Nemu />,
      description: t('integration:nemuDescription'),
      disabled: true,
      route: '/nemu',
      category: 'tracking',
    },
    {
      id: 16,
      name: 'xTracky',
      icon: <Xtracky />,
      description: t('integration:xtrackyDescription'),
      disabled: false,
      route: '/xtracky',
      category: 'tracking',
    },
    {
      id: 17,
      name: 'RedTrack',
      icon: <RedTracky />,
      description: t('integration:redtrackDescription'),
      disabled: true,
      route: '/redtrack',
      category: 'tracking',
    },
    // Automations
    {
      id: 18,
      name: 'ActiveCampaign',
      icon: <Active />,
      description: t('integration:activeCampaignDescription'),
      disabled: false,
      route: '/active_campaign',
      category: 'automations',
    },
    {
      id: 32,
      name: 'Tauk',
      icon: <TaukIcon />,
      description: t('integration:taukDescription'),
      disabled: false,
      route: '/tauk',
      category: 'automations',
    },
    {
      id: 19,
      name: 'Hotzapp',
      icon: <Hotzap />,
      description: t('integration:hotzappDescription'),
      disabled: false,
      route: '/hotzapp',
      category: 'automations',
    },
    {
      id: 20,
      name: 'Voxuy',
      icon: <Voxuy />,
      description: t('integration:voxuyDescription'),
      disabled: true,
      route: '/voxuy',
      category: 'automations',
    },
    {
      id: 21,
      name: 'BotConversa',
      icon: <Bot />,
      description: t('integration:botConversaDescription'),
      disabled: false,
      route: '/bot_conversa',
      category: 'automations',
    },
    // VSL
    {
      id: 30,
      name: 'VTurb',
      icon: <Vturb />,
      description: t('integration:vturbDescription'),
      disabled: false,
      route: '/vturb',
      category: 'vsl',
    },
    // SMS
    {
      id: 22,
      name: 'SMS Funnel',
      icon: <Sms />,
      description: t('integration:smsFunnelDescription'),
      disabled: false,
      route: '/sms_funnel',
      category: 'sms',
    },
    {
      id: 23,
      name: 'Mex10',
      icon: <Mex />,
      description: t('integration:mex10Description'),
      disabled: true,
      route: '/mex10',
      category: 'sms',
    },
    // Global Encapsulation
    {
      id: 24,
      name: 'Eagle Labs',
      icon: <Eagle />,
      description: t('integration:eagleLabsDescription'),
      disabled: false,
      route: '/eagle_labs',
      category: 'globalEncapsulation',
    },
    {
      id: 31,
      name: 'Jetpack (JetStream)',
      icon: <JetpackIcon />,
      description: t('integration:jetpackDescription'),
      disabled: false,
      route: '/jetpack',
      category: 'globalEncapsulation',
    },
    {
      id: 25,
      name: 'ShipOffers',
      icon: <ShipOffers />,
      description: t('integration:shipOffersDescription'),
      disabled: false,
      route: '/ship-offers',
      category: 'globalEncapsulation',
    },
    {
      id: 34,
      name: 'RedRock',
      icon: <RedRock />,
      description: t('integration:redRockDescription'),
      disabled: false,
      route: '/red_rock',
      category: 'globalEncapsulation',
    },
    {
      id: 26,
      name: 'Tb3',
      icon: <Tb3 />,
      description: t('integration:tb3Description'),
      disabled: false,
      route: '/tb3',
      category: 'globalEncapsulation',
    },
    // Invoices
    {
      id: 27,
      name: 'Notazz',
      icon: <Notaz />,
      description: t('integration:notazzDescription'),
      disabled: false,
      route: '/notazz',
      category: 'invoices',
    },
    {
      id: 28,
      name: 'eNotas',
      icon: <Enotas />,
      description: t('integration:enotasDescription'),
      disabled: false,
      route: '/enotas',
      category: 'invoices',
    },
    // Webhooks
    {
      id: 29,
      name: 'Webhook Genérico',
      icon: <Webhook />,
      description: t('integration:webhookDescription'),
      disabled: false,
      route: '/webhook',
      category: 'webhooks',
    },
    {
      id: 33,
      name: 'HelpGrid',
      icon: <HelpGridIcon />,
      description: t('integration:helpgridDescription'),
      disabled: false,
      route: '/helpgrid',
      category: 'automations',
    },
  ];

  return allIntegrations;
};
